import React from 'react';
import './Measure.css';

const Measure = ({ project }) => {
  return (
    <div className="measure-container">
      <div className="section-header">
        <h3>Measure</h3>
        <p>Measurement tools and utilities</p>
      </div>
      
      <div className="measure-tools">
        <button className="tool-btn">
          <i className="fas fa-ruler"></i>
          <span>Distance</span>
        </button>
        <button className="tool-btn">
          <i className="fas fa-square"></i>
          <span>Area</span>
        </button>
        <button className="tool-btn">
          <i className="fas fa-cube"></i>
          <span>Volume</span>
        </button>
      </div>
    </div>
  );
};

export default Measure;
